import {
  REMOVE_CREDENTIALS,
  TOKEN_REFRESHED,
  CHECK_LOGIN,
  removeCredentials,
  LOAD_CREDENTIALS,
  loadCredentials,
  SET_CONFIG_TRACKING_COLUMNS,
  SET_CONFIG_TRACKING_TABLE_CAR_REGIS_COLUMNS,
  SET_CONFIG_TRACKING_TABLE_DRIVER_COLUMNS,
  SET_CONFIG_HOME_DASHBOARD_WIDGET,
  SET_LOCATION_VISIBILITY,
  SET_VEHICLE_VISIBILITY,
  SET_LOCATION_GROUP_VISIBILITY,
  SET_VEHICLE_GROUP_VISIBILITY,
  SET_MATERIAL_VISIBILITY,
  CHANGE_LANG,
  LOAD_FAVORITE_MENU,
  CREATE_FAVORITE_MENU,
  DELETE_FAVORITE_MENU,
  SET_ORG_CHART_FILTER,
  SET_ORG_CHART_TRACKING_FILTER,
} from './actions'

const initialState = {
  tokenExp: null,
  accessToken: null,
  profile: null,
  done: false,
  status: '',
  msg: '',
  sub_msg: '',
  // wrong password on an iSupply-password account: tries left before the lock
  remaining_attempts: null,
  loading: false,
  favMenuLoading: false,
  lang: 'th',
  favoriteMenu: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CREDENTIALS:
      const {
        payload: { token, tokenExp, profile, done, msg },
      } = action
      let {
        company_id,
        company_name,
        id,
        is_admin,
        is_super,
        is_vendor,
        is_mill,
        is_plant,
        username,
        firstname,
        lastname,
        phone,
        vehicle_visibility,
        location_visibility,
        vehicle_group_visibility,
        location_group_visibility,
        permissions,
        config,
        google_map_key,
        longdo_map_key,
        data_visibility_node,
        org_chart_vehicle_visibility,
        org_chart,
        relate_company,
        web_login_redirect,
        is_bluenet_user,
      } = profile

      permissions = JSON.parse(permissions || '{}')
      config = JSON.parse(config || '{}')

      return {
        ...initialState,
        tokenExp: tokenExp,
        accessToken: token,
        profile: {
          ...profile,
          permissions,
          config,
          data_visibility_node,
          org_chart_vehicle_visibility,
          org_chart,
          relate_company,
          web_login_redirect,
          is_bluenet_user,
          is_mill,
          is_plant,
        },
        done: done,
        msg: msg,
      }
    case TOKEN_REFRESHED: {
      // keep favoriteMenu and the rest — LOAD_CREDENTIALS resets to initialState
      const { token, tokenExp } = action.payload
      if (!state.done || !token) return state
      return {
        ...state,
        accessToken: token,
        tokenExp,
        profile: state.profile ? { ...state.profile, exp: tokenExp, tokenExp } : state.profile,
      }
    }
    case REMOVE_CREDENTIALS:
      removeCredentials()
      return initialState
    case CHECK_LOGIN.REQUEST: {
      return {
        ...state,
        loading: true,
      }
    }
    case CHECK_LOGIN.SUCCESS: {
      let {
        payload: {
          token,
          tokenPayload,
          permissions,
          config,
          vehicle_list,
          location_list,
          material_list,
          exactly_location,
          mill_location_list,
          plant_location_list,
          is_mill,
          is_plant,
          vehicle_group_list,
          location_group_list,
          status,
          msg,
          data_visibility_node,
          org_chart_vehicle_visibility,
          org_chart,
          user_history_logon_id,
          relate_company,
          web_login_redirect,
          is_bluenet_user,
          cb,
        },
      } = action

      let {
        exp,
        company_id,
        company_name,
        id,
        is_admin,
        is_super,
        is_vendor,
        is_gps_vendor,
        username,
        firstname,
        lastname,
        phone,
        // vehicle_visibility,
        // location_visibility,
        // permissions,
        // config,
        google_map_key,
        longdo_map_key,
      } = tokenPayload

      permissions = JSON.parse(permissions || '{}')
      config = JSON.parse(config || '{}')
      typeof cb != 'undefined' && cb()
      const url = new URL(window.location.href)
      if (url.pathname == '/login-by-token') {
        window.location.replace('/')
      }

      return {
        ...initialState,
        lang: 'th',
        accessToken: token,
        tokenExp: exp,
        profile: {
          ...tokenPayload,
          vehicle_visibility: vehicle_list,
          location_visibility: location_list,
          material_visibility: material_list,
          exactly_location,
          mill_location_list,
          plant_location_list,
          is_mill,
          is_plant,
          vehicle_group_visibility: vehicle_group_list,
          location_group_visibility: location_group_list,
          permissions,
          config,
          data_visibility_node,
          org_chart_vehicle_visibility,
          org_chart,
          relate_company,
          user_history_logon_id,
          is_gps_vendor,
          web_login_redirect,
          is_bluenet_user,
        },
        done: true,
        msg: msg,
        status: status,
        loading: false,
      }
    }
    case CHECK_LOGIN.FAILURE: {
      const {
        payload: { status, msg, sub_msg, remaining_attempts },
      } = action

      return {
        ...initialState,
        msg: msg,
        sub_msg: sub_msg,
        remaining_attempts: remaining_attempts === undefined ? null : remaining_attempts,
        status: status,
        loading: false,
      }
    }

    case SET_CONFIG_TRACKING_COLUMNS:
      const {
        payload: { p, columns, showMinimalMarker },
      } = action
      let getShowminimalMarker = showMinimalMarker
      if (typeof showMinimalMarker == 'undefined' || showMinimalMarker == null)
        getShowminimalMarker = false
      config = JSON.parse(config || '{}')

      return {
        ...state,
        profile: {
          ...state.profile,
          config: {
            ...state.profile.config,
            menu: {
              ...state.profile.config.menu,
              tracking: {
                ...state.profile.config.menu.tracking,
                columns,
                show_minimal_marker: getShowminimalMarker,
              },
            },
          },
        },
      }

    case SET_CONFIG_TRACKING_TABLE_CAR_REGIS_COLUMNS:
      const {
        payload: { CarRegisColumns },
      } = action
      //   console.log('action Regis', action)
      return {
        ...state,
        profile: {
          ...state.profile,
          config: {
            ...state.profile.config,
            menu: {
              ...state.profile.config.menu,
              tracking: {
                ...state.profile.config.menu.tracking,
                columns_car_plate_no: CarRegisColumns,
              },
            },
          },
        },
      }

    case SET_CONFIG_TRACKING_TABLE_DRIVER_COLUMNS:
      const {
        payload: { DriverColumns },
      } = action

      return {
        ...state,
        profile: {
          ...state.profile,
          config: {
            ...state.profile.config,
            menu: {
              ...state.profile.config.menu,
              tracking: {
                ...state.profile.config.menu.tracking,
                columns_driver: DriverColumns,
              },
            },
          },
        },
      }

    case SET_CONFIG_HOME_DASHBOARD_WIDGET:
      const { payload: layout } = action
      config = JSON.parse(config || '{}')

      if (state.done)
        return {
          ...state,
          profile: {
            ...state.profile,
            config: {
              ...state.profile.config,
              home_dashboard: {
                ...state.profile.config.home_dashboard,
                layout,
              },
            },
          },
        }
      else return initialState

    case SET_ORG_CHART_FILTER: {
      const {
        payload: { filters },
      } = action
      //   console.log(filters.menu.concrete_dashboard.init_filter);
      config = JSON.parse(config || '{}')
      let newState = { ...state }
      newState['profile']['config']['menu']['concrete_dashboard'][
        'init_filter'
      ] = { ...filters.menu.concrete_dashboard.init_filter }
      return newState
    }

    case SET_ORG_CHART_TRACKING_FILTER: {
      const {
        payload: { filters },
      } = action
      //   console.log(filters.menu.concrete_dashboard.init_filter);
      config = JSON.parse(config || '{}')
      let newState = { ...state }
      newState['profile']['config']['menu']['tracking']['init_filter'] = {
        ...filters.menu.tracking.init_filter,
      }
      return newState
    }
    case CHANGE_LANG:
      return {
        ...state,
        lang: action.payload.lang,
      }
    case LOAD_FAVORITE_MENU.REQUEST:
      return {
        ...state,
        favMenuLoading: true,
      }
    case LOAD_FAVORITE_MENU.SUCCESS:
      return {
        ...state,
        favoriteMenu: action.payload.lists,
        favMenuLoading: false,
      }
    case CREATE_FAVORITE_MENU.REQUEST:
      return {
        ...state,
        favMenuLoading: true,
      }
    case CREATE_FAVORITE_MENU.SUCCESS:
      return {
        ...state,
        favoriteMenu: action.payload.res,
        favMenuLoading: false,
      }
    case DELETE_FAVORITE_MENU.REQUEST:
      return {
        ...state,
        favMenuLoading: true,
      }
    case DELETE_FAVORITE_MENU.SUCCESS:
      return {
        ...state,
        favoriteMenu: action.payload.res,
        favMenuLoading: false,
      }

    // add location_visibility in session
    case SET_LOCATION_VISIBILITY: {
      let {
        location_visibility,
        plant_location_list,
        mill_location_list,
      } = action.payload
      if (state.done) {
        return {
          ...state,
          profile: {
            ...state.profile,
            location_visibility: location_visibility,
            plant_location_list: plant_location_list,
            mill_location_list: mill_location_list,
          },
        }
      } else {
        return initialState
      }
    }

    // add vahicle_visibility in session
    case SET_VEHICLE_VISIBILITY: {
      let vehicle_visibility_new = action.payload
      if (state.done)
        return {
          ...state,
          profile: {
            ...state.profile,
            vehicle_visibility: vehicle_visibility_new,
          },
        }
      else {
        return initialState
      }
    }

    // add vehicle_group_visibility in session
    case SET_VEHICLE_GROUP_VISIBILITY: {
      let vehicle_group_visibility_new = action.payload
      if (state.done) {
        return {
          ...state,
          profile: {
            ...state.profile,
            vehicle_group_visibility: vehicle_group_visibility_new,
          },
        }
      } else {
        return initialState
      }
    }

    // add vehicle_group_visibility in session
    case SET_LOCATION_GROUP_VISIBILITY: {
      let location_group_visibility_new = action.payload
      if (state.done) {
        return {
          ...state,
          profile: {
            ...state.profile,
            location_group_visibility: location_group_visibility_new,
          },
        }
      } else {
        return initialState
      }
    }

    case SET_MATERIAL_VISIBILITY: {
      let material_visibility_new = action.payload
      if (state.done) {
        return {
          ...state,
          profile: {
            ...state.profile,
            material_visibility: material_visibility_new,
          },
        }
      } else {
        return initialState
      }
    }

    default:
      return state
  }
}
